import styled, { css, DefaultTheme } from 'styled-components';
import { Box } from '@user-portal/wikr-components';

import { color } from 'theme/selectors';
import mediaQueries from '../../theme/mediaQueries';

const getLineWidth = (theme: DefaultTheme) => css`calc(100% - ${theme['default-indent']}px)`;

export const TabsWrapper = styled(Box)`
    display: flex;
    justify-content: center;
    margin-top: 30px;

    ${mediaQueries.tablet} {
        justify-content: flex-start;
    }
`;

export const TabButton = styled.button<{ $isActive: boolean }>`
    padding: 12px 18px;
    position: relative;
    outline: none;
    background-color: transparent;
    border: none;
    cursor: pointer;

    &:hover {
        > * {
            color: ${color('text-main')};
        }

        &:after {
            width: ${({ theme }) => getLineWidth(theme)};
        }
    }


    &:after {
        content: '';
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        bottom: -1px;
        height: 2px;
        transition: 0.3s;
        width: ${({ $isActive, theme }) => ($isActive ? getLineWidth(theme) : 0)};
        background: ${color('primary-default')};
    }
}
`;
